import React from "react"
import PropTypes from "prop-types"
import { Tooltip } from "@mui/material"
import i18n from "i18n"

const CheckboxCert = ({ checked, onChange, disabled }) => {
  return (
    <label
      style={{
        paddingInline: "15px",
        marginBottom: "0px",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "default" : "pointer",
      }}
    >
      <Tooltip arrow title={i18n.t("partida.certifyPartida")}>
        <input
          type="checkbox"
          checked={!!checked}
          onChange={onChange}
          disabled={disabled}
          style={{
            width: 18,
            height: 18,
            minWidth: 18,
            minHeight: 18,
            flexShrink: 0,
            alignSelf: "center",
            boxSizing: "border-box",
            cursor: disabled ? "default" : "pointer",
          }}
        />
      </Tooltip>
    </label>
  )
}

CheckboxCert.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default CheckboxCert
